export const GOOGLE_MAPS_CONFIG = {
  apiKey: import.meta.env.VITE_APP_GOOGLE_MAPS_API_KEY,
  libraries: ['places'],
  region: 'UY',
  language: 'es',
  defaultCenter: {
    lat: -34.9011,
    lng: -56.1645
  }
};
